import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  type SelectChangeEvent,
} from "@mui/material";
import { useMemo } from "react";
import { type SeverityRange, useSeverityRangesFilterFromQuery } from "../../hooks/useRouteParams";

export interface SeverityRangesFilterProps {
  label?: string;
}

const ALL_OPTIONS: readonly SeverityRange[] = ["TRACE", "DEBUG", "INFO", "WARN", "ERROR", "FATAL"];

export function SeverityRangesFilter({ label = "Severity Ranges" }: SeverityRangesFilterProps) {
  const { severityRanges, setSeverityRanges } = useSeverityRangesFilterFromQuery();

  // For display: if no filter is set (empty in URL), show all selected.
  const value = useMemo<SeverityRange[]>(
    () => (severityRanges.length === 0 ? [...ALL_OPTIONS] : severityRanges),
    [severityRanges],
  );

  const handleChange = (event: SelectChangeEvent<SeverityRange[]>) => {
    const nextValue = event.target.value as SeverityRange[];
    setSeverityRanges(nextValue);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 240 }}>
      <InputLabel id="severity-ranges-label">{label}</InputLabel>
      <Select<SeverityRange[]>
        labelId="severity-ranges-label"
        multiple
        value={value}
        label={label}
        onChange={handleChange}
        renderValue={(selected) => {
          if (selected.length === ALL_OPTIONS.length) return "All";
          if (selected.length === 0) return "All";
          return selected.join(", ");
        }}
      >
        {ALL_OPTIONS.map((opt) => (
          <MenuItem key={opt} value={opt}>
            <Checkbox checked={value.includes(opt)} size="small" />
            <ListItemText primary={opt} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
